export const types = {
  UPDATE_FILE: "UPDATE_FILE",
  UPDATE_FILE_SUCCESS: "UPDATE_FILE_SUCCESS",
  UPDATE_FILE_FAILURE: "UPDATE_FILE_FAILURE",
  DELETE_FILE: "DELETE_FILE",
  DELETE_FILE_SUCCESS: "DELETE_FILE_SUCCESS",
  DELETE_FILE_FAILURE: "DELETE_FILE_FAILURE",
};
